import { type FC, type ReactNode } from "react";

import { clsx } from "clsx";

// An action that reads like a link: BasicLink's style on a button. `rose`
// for one that removes something; `medium` for one beside a button.
export const LinkButton: FC<{
  tone?: "action" | "rose";
  weight?: "normal" | "medium";
  onClick(): void;
  children: ReactNode;
}> = ({ tone = "action", weight = "normal", onClick, children }) => (
  <button
    type="button"
    className={clsx(
      tone === "rose" ? "font-semibold text-rose-700 hover:underline" : "link",
      weight === "medium" && "font-medium",
      "self-start text-[13px]",
    )}
    onClick={onClick}
  >
    {children}
  </button>
);
